<template>
  <div>
    <!-- 落地页url -->
    <div v-if="formKey === 'site_url'">
      <el-link :href="formItem.value" :underline="false" type="primary" target="_blank">{{ formItem.value }}</el-link>
    </div>
    <!-- 样式预览 -->
    <div v-if="formKey === 'thumbnail'">
      <material-list :form-item="formItem" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'material-list': () => import('@/views/auxiliary/batch-tool/source-template/components/material-list'),
  },
  props: {
    // 表单项键名
    formKey: {
      type: String,
      required: true,
    },
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
  },
};
</script>
